module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3sKUzQAPa80IsOGgmOGiig-4fc6f6c428875e6e59365d8568b730c1.jpg";